import { call, select, put } from 'redux-saga/effects';
import { teamsModel } from '../../../teams';
import { callApi } from '../../../../shared/api';
import { RT } from '../../../../shared/types';
import { callModel } from '../index';
import { createNotification, snackbarModel } from '../../../snackbar';
import { JSONContentBuilder } from '@distribute/shared/tiptap/json-content';
import { DEFAULT_RATIO } from '@distribute/shared/utils';

export function* loadCallDetailsForEditor({
  payload: { id, isInsertSummary = false, cb },
}: ReturnType<typeof callModel.actions.loadCallDetailsForEditor>) {
  try {
    if (isInsertSummary) {
      yield put(callModel.actions.setIsInsertCallLoading(true));
    }

    const team: RT<typeof teamsModel.selectors.selectCurrentTeamWithError> =
      yield select(teamsModel.selectors.selectCurrentTeamWithError);

    const callDetails: RT<typeof callApi.getCall> = yield call(
      callApi.getCall,
      id,
      { teamId: team.id }
    );

    if (isInsertSummary) {
      const { muxAsset, summaries } = callDetails;

      const content = JSONContentBuilder.videoRecord({
        attrs: {
          playbackId: muxAsset.playback.id,
          aspectRatio: muxAsset.data.aspectRatio || DEFAULT_RATIO,
          prefix: id,
        },
      }).asArray();

      const summary = summaries[0];

      if (summary?.content) {
        const summaryContent = JSONContentBuilder.callSummary(
          summary.type,
          summary.content
        );
        content.push(...summaryContent);
      }
      cb?.(content);
    } else {
      yield put(callModel.actions.setCurrentCall(callDetails));
    }
  } catch (err: unknown) {
    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification('error', 'Failed to load call details')
      )
    );
  } finally {
    yield put(callModel.actions.setIsInsertCallLoading(false));
  }
}
